export default {"src":"/_next/static/media/checklist.1607d1b2.svg","height":220,"width":220,"blurWidth":0,"blurHeight":0};